import { NetworkService } from "../services";
import { store } from "../store";
import { GET_COLLECTIONS_ACTION } from "../store/collection/collection.action";

class VectorAIBase {
  protected apiKey: string | null = null;
  protected username: string | null = null;

  public async get<T>(url: string, params?: object) {
    const auth = this.getAuth();
    return await NetworkService.get<T>(
      NetworkService.buildUrlFromQueryParams(url, {
        ...auth,
        ...(params || {}),
      })
    );
  }

  public async post<T>(url: string, body?: any) {
    const auth = this.getAuth();
    return await NetworkService.post<T>(url, {
      ...auth,
      ...(body || {}),
    });
  }

  public setAuth(apiKey: string, username: string) {
    this.apiKey = apiKey;
    this.username = username;

    sessionStorage.setItem(
      "VECTOR_AI_AUTH",
      JSON.stringify({ apiKey: this.apiKey, username: this.username })
    );
  }

  public getAuth() {
    if (this.apiKey && this.username) {
      return {
        api_key: this.apiKey,
        username: this.username,
      };
    }
    const localStorageData = sessionStorage.getItem("VECTOR_AI_AUTH");
    if (localStorageData) {
      const parsedData = JSON.parse(localStorageData);
      return {
        api_key: parsedData.apiKey,
        username: parsedData.username,
      };
    }
    return {
      api_key: "",
      username: "",
    };
  }

  public logout() {
    sessionStorage.removeItem("VECTOR_AI_AUTH");
    this.apiKey = null;
    this.username = null;
    store.dispatch(GET_COLLECTIONS_ACTION.reset());
  }
}

export default VectorAIBase;
